import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ListService} from '../../services/list.service';

@Component({
  selector: 'app-list',
  templateUrl: './list.component.html',
  styleUrls: ['./list.component.css']
})
export class ListComponent implements OnInit {
  selectedItem: number = 0;
  selectedItemID: number = 0;
  listName: string;
  itemName: string = "";
  newItemName: string = '';
  editedItem: -1;
  
  orderedListItem = -1;

  editedList = {
    id: "",
    settings: 0,
    title: "",
    idUser: localStorage.getItem("idUser"),
    state: 0
  };

  constructor(private route: ActivatedRoute, private listService: ListService) { }

  ngOnInit() {
    this.listService.idList = this.route.snapshot.paramMap.get('id');
    this.listService.getList();
  }

  selectItem(i, itemID){
    this.selectedItem = i;
    this.selectedItemID = itemID;
  }

  addItem(){
    this.listService.addItem(this.itemName);
    this.itemName = "";
  }

  editItem(i){
    this.editedItem = i;
    this.itemName = this.listService.list.items[i].title;
  }
  updateItem(){
    this.listService.updateItemName(this.editedItem,this.itemName);
    this.editedItem = -1;
  }

  toggleCheckbox(i){
    this.listService.toggleCheckbox(i);
  }

  removeItem(i, id){
    this.listService.removeItem(i, id);
  }

  editList(){
    this.editedList.id = this.listService.list.id;
    this.editedList.title = this.listService.list.title;
    this.editedList.settings = this.listService.list.settings;
  }

  updateList(){
    this.listService.updateList(this.editedList);
  }

  dropSuccess(i){
    this.orderedListItem = -1;
    this.listService.changeOrder(i+1);
  }

  dragStart(i){
    this.orderedListItem = i;
  }

  dragEnd(){
    this.orderedListItem = -1;
  }

  orderUp(i){
    this.listService.orderUp(i);
  }
  orderDown(i){
    this.listService.orderDown(i);
  }

}
  


// WEBPACK FOOTER //
// ./src/app/components/list/list.component.ts